<template>
  <div class="template-single-layout">
    <template v-if="loaded">
      <div class="template-single__heading">
        <slot name="template-heading" />
      </div>
      <div class="template-single__content">
        <AppTabs :tabs-names="tabsName" :current-tab="tabs[0].slug" router-hash>
          <!-- tabs -->
          <div v-for="tab in tabs" :key="`tab-${tab.name}`" :slot="tab.slug" class="app__tabs-tab">
            <slot :name="tab.slug" />
          </div>
        </AppTabs>
      </div>
    </template>
    <div v-else class="template-single__loader">
      <AppSpinnerDot :size="20" />
    </div>
  </div>
</template>

<script>
// Components
import AppTabs from 'Ui/AppTabs'
import AppSpinnerDot from 'Ui/AppSpinnerDot'

export default {
  name: 'TemplateSingleLayout',

  components: {
    AppTabs,
    AppSpinnerDot,
  },

  props: {
    tabs: {
      type: Array,
      required: true,
    },

    loaded: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    tabsName() {
      const names = this.tabs.map((tab) => tab.name)
      return names
    },

    isEditPage() {
      return this.$route.name === 'template-edit'
    },

    isDetailPage() {
      return this.$route.name === 'template-details'
    },

    variantClass() {
      return this.$route.name
    },
  },
}
</script>

<style scoped>
.template-single__heading {
  display: grid;
  align-items: center;
  position: sticky;
  width: 100%;
  top: var(--d-topbar-offset);
  padding: 10px 30px 15px;
  background-color: #fff;
  border-bottom: 1px solid var(--c-secondary-400);
  z-index: 2;
  min-height: 66px;
}

.template-single__heading >>> .app-heading {
  font-size: 24px;
  color: var(--c-magenta-500);
}

.template-single__heading >>> .app-spinner {
  text-align: left;
}

.template-single__content {
  padding-bottom: 40px;
  /* min-height: 100vh; */
}

.template-single__content >>> .app-tabs {
  position: relative;
}

.template-single__content >>> .app-tabs:before {
  position: absolute;
  content: '';
  width: 100%;
  height: 2px;
  top: 47px;
  background-color: var(--c-secondary-500);
}

.template-single__content >>> .app-tabs__header,
.template-single__content >>> .app-tabs__wrapper {
  max-width: 578px;
  margin: 0 auto;
}

.template-single__content >>> .app-tabs__wrapper {
  padding: 30px 20px;
  height: 100%;
}

.template-single__content >>> .app-tabs__header-item {
  border-bottom: 2px solid transparent;
  padding: 15px 20px;
}

.template-single__content >>> .app-tabs__header-item.active {
  border-color: var(--c-primary);
}

.template-single__loader {
  position: relative;
  max-width: 880px;
  margin: 0 auto;
  min-height: 100vh;
}

.template-single__loader .app-spinner {
  position: absolute;
  top: 20%;
  left: 40%;
  transform: translate(-40%, -20%);
}

.template-single__content >>> .tab-section > .app-heading {
  font-size: 18px;
  line-height: 32px;
  color: var(--c-primary);
  margin-bottom: 10px;
}

.template-single__content >>> .tab-section .diy-tooltip {
  position: relative;
  top: -8px;
}

/* responsive -------------- */
@media (max-width: 980px) {
  .template-single__heading {
    top: var(--m-topbar-offset);
  }
}

@media (max-width: 680px) {
  .template-single__content >>> .app-tabs__header {
    padding: 0;
  }
}
</style>
